import $ from 'jquery';
import singleEdit from '@ui/comments/single-edit';
import uiActions from '@ui/comments/ui-actions';
import addComment from '@ui/comments/add-comment';
import exposeSharedComment from '@ui/comments/expose-shared-comment';
import filters from '@ui/comments/filters';
import CommentsView from '@ui/comments/comments-view';
import { siteModel } from 'models/SiteModel';
import CommentsService from '@ui/comments/CommentService';
import CommentModel from 'models/CommentModel';
import AdsSlots from "@ui/comments/ads-slots";

import { mustacheContent } from '@ui/mustache-content';

export const elements = {
    wrapper: '.c-comments__wrapper',
    modal: '.comments-modal',
    input: '.c-comments__main--base-comments',
    editor: '.text-editor',
};

export const preventHtmlInMainComment = () => {
    const $input = $(elements.input);
    const $editor = $input.find(elements.editor);
    const $button = $input.find(elements.edit);

    $editor.on('paste', function(event) {
        event.preventDefault();

        const pasted = event.originalEvent
        .clipboardData
        .getData('text/plain');

        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, pasted);
        } else {
            document.execCommand('paste', false, pasted);
        }
        const value = $editor.text();

        if (CommentModel.isMessageCorrect(value)) {
            $button.removeClass('hide');
        }
    });
};

/**
 * Close comments section on ad blocker detect success
 */
const closeCommentsSection = () => {
    $('.c-comments-loader').remove();
    $('.aci-adblock-information').addClass('aci-visible');
    $('.aci-adblock-to-apply').addClass('aci-applied');
    $('.aci-to-hide').addClass('aci-hide-it');

    return false;
};

/**
 * Init comments section on ad blocker detect fail
 *
 * @param {} params - init params
 */
const initCommentsSection = (params) => {
    if (window.__articleComments__ === false) {
        return;
    }

    /**
     * Comment dynamic ajax render
     */
    mustacheContent.renderCommentsSection();

    const commentsCollection = CommentsService.getVisibleCommentsCollection();
    const commentsView = new CommentsView(commentsCollection);

    singleEdit.init(params);
    uiActions.init(params);
    addComment.init(params);
    filters.init(params);

    preventHtmlInMainComment();

    const filtersView = new filters.CommentsFilterView();
    filtersView.render();

    filtersView.getModerationLabel().off().click(() => {
        const isInModerationMode = filtersView.toggleModerationMode();

        document.dispatchEvent(new CustomEvent('ChangedModerationMode', {
            detail: { isInModerationMode },
        }));
    });

    const User = siteModel.get('User');
    if (User.isModerator()) {
        User.set('isInModerationMode', true);
    }

    /**
     * Verify comments count to show sticky right adsesnse section
     */
    document.addEventListener('CommentsInitialised', () => {
        const comments = CommentsService.getVisibleCommentsCollection().get('comments');
        if (comments.length >= 5) {
            $('.scm-article-show').addClass('show-sticky-adsense sticky-section-min-height');
        }
        $('#shoutbox-paginator').show();
    });

    CommentsService.init();
};

export const init = (params) => {
    $(window).ready(() => {
        /**
         * Add event listener to react on adBlock
         */

        AdsSlots.init(params);

        window.addEventListener('onAdBlockerDetectionFinish', e => {
            if (e.detail) {
                closeCommentsSection();
            } else {
                initCommentsSection(params);
            }
        }, false);
    });

    /*
     * resize editor hack - alternatively use
     * word-break fixed with width: 0 - on form container
     *
    const resizeEditors = function() {
        const input = $(elements.input);
        const figure = input.children('figure');
        const form = input.children('form');
        const editor = form.find(elements.editor);
        const width = input.width() - figure.outerWidth(true) - 50;

        form.css('width', width);
    }
    */
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/index.js